import React, { useContext, createContext } from 'react';
import { useTranslations } from 'js/hooks/i18n';

const TranslationContext = createContext();

export const withTranslations = Wrapped => (props) => {
    const translate = useTranslations('playtech.mobile.mystery-parcel-page.');

    return <TranslationContext.Provider value={translate}>
        <Wrapped {...props} />
    </TranslationContext.Provider>;
};

export default () => useContext(TranslationContext);
